var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 100,
    viewBox: "0 0 97 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6233 31.4964L93.9313 24.2988L87.3231 17.7905L79.3352 25.6478C74.4265 22.7431 68.708 21.0398 62.5697 21.0398C44.5345 21.0398 29.8484 35.494 29.8484 53.2663C29.8484 71.0387 44.5345 85.4929 62.5697 85.4929C80.6049 85.4929 95.2909 71.0387 95.2909 53.2663C95.2909 45.1925 92.1918 37.414 86.6233 31.4865V31.4964ZM62.5697 76.2966C49.6831 76.2966 39.1959 65.9679 39.1959 53.2762C39.1959 40.5844 49.6831 30.2558 62.5697 30.2558C75.4562 30.2558 85.9434 40.5844 85.9434 53.2762C85.9434 65.9679 75.4562 76.2966 62.5697 76.2966Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8907 39.4619H67.2382V57.8743H57.8907V39.4619ZM53.2119 7.23535H71.9069V16.4415H53.2119V7.23535Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1694 30.2461H6.47437V39.4523H25.1694V30.2461Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1694 67.0806H6.47437V76.2867H25.1694V67.0806Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4509 48.668H1.7959V57.8742H20.4509V48.668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloj);
export default __webpack_public_path__ + "static/media/reloj.4cf8d8147fd8295cf5a1cb34172ce9d6.svg";
export { ForwardRef as ReactComponent };